import styled from "@emotion/styled";
import Spinner from "react-bootstrap/Spinner";

const LoadingContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const OverlayLoading = () => {
    return (
        <LoadingContainer>
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </LoadingContainer>
    );
};

export default OverlayLoading;
